import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The selector's pin: the solid, tilted pushpin the design draws. Lucide's `pin` is an upright
 * outline, so the glyph is kept here. Always beside a label or inside a named button, so it is
 * decoration, and it takes its colour from `currentColor`.
 */
@Component({
  selector: 'app-pin-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true', style: 'display: inline-flex' },
  template: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" focusable="false">
      <path
        d="M9.15 2.76c.1 0 .19.04.27.11l3.71 3.71a.38.38 0 010 .53c-.36.36-.8.44-1.13.44-.13 0-.25-.01-.34-.03L9.31 9.88c.06.25.1.5.12.76.03.53-.02 1.27-.54 1.78a.38.38 0 01-.53 0L6.23 10.3l-2.38 2.38c-.15.15-.92.68-1.06.53-.15-.15.38-.92.53-1.06L5.7 9.77 3.58 7.64a.38.38 0 010-.53c.52-.52 1.26-.57 1.78-.54.26.02.51.06.76.12l2.35-2.35a2.4 2.4 0 01-.03-.35c0-.32.08-.77.44-1.13.07-.07.17-.11.27-.11z"
        fill="currentColor"
      />
    </svg>
  `,
})
export class PinIconComponent {}
